const validVariants = Object.freeze({
    primary: true,
    secondary: true,
    light: true,
    dark: true,
    info: true,
    success: true,
    danger: true,
    warning: true,
});
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function isVariant(obj) {
    return typeof obj === 'string' && Object.prototype.hasOwnProperty.call(validVariants, obj);
}
